function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFB12F",
  strokeWidth: 2,
  d: "M1 19.928l12.08 1.842 2.081-10.384 11.275 1.718 2.241-11.182",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgStroke3 = function SvgStroke3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzBweCIgaGVpZ2h0PSIyM3B4IiB2aWV3Qm94PSIwIDAgMzAgMjMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+U3Ryb2tlIDM8L3RpdGxlPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4KICAgICAgICA8cG9seWxpbmUgaWQ9IlN0cm9rZS0zIiBzdHJva2U9IiNGRkIxMkYiIHN0cm9rZS13aWR0aD0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcuMDk3MTAzLCAxNC4xNTAxOTUpIHJvdGF0ZSgtMzUuMDAwMDAwKSB0cmFuc2xhdGUoLTE3LjA5NzEwMywgLTE0LjE1MDE5NSkgIiBwb2ludHM9IjAuNTk3MTAyNjk0IDkuNjUwMTk1NCA5LjQzNjM4ODQxIDE4LjA4NzY5NTQgMTcuMDk3MTAyNyAxMC43NzUxOTU0IDI1LjM0NzEwMjcgMTguNjUwMTk1NCAzMy41OTcxMDI3IDEwLjc3NTE5NTQiPjwvcG9seWxpbmU+CiAgICA8L2c+Cjwvc3ZnPg==";
export { SvgStroke3 as ReactComponent };